export const HOME_PATH = '/';
export const RECIPES_PATH = '/receitas';
export const EVENTS_PATH = '/eventos';
export const COACHING_PATH = '/coaching';
export const WHO_AM_I_PATH = '/quem-sou';
